import { render, staticRenderFns } from "./BaseDataTableRowSelect.vue?vue&type=template&id=0b82deea&"
import script from "./BaseDataTableRowSelect.vue?vue&type=script&lang=js&"
export * from "./BaseDataTableRowSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseDataTableRowSelect.vue?vue&type=style&index=0&id=0b82deea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports